
/**
  * placeholder for now
  */
  
class LMCustomProduct extends HTMLElement {

  #formId;
  
  constructor() {
    super();
  };

  /**
    * called after appended to the DOM
    */
  connectedCallback()
  {
    this.addNotAvail();
    
    //pull the form id from the section
    this.#formId = 'product-form-' + this.closest('product-info').dataset.section;
  }

  //returns the product cart form
  formId() { return this.#formId; }
  getForm() { return document.querySelector('#' + this.#formId); }

  /**
    * adds a message to display when customization isn't enabled
    */
  addNotAvail()
  {
    const wrapper = document.createElement('div');
    wrapper.classList.add('lm-custom-product-not-available');
    
    wrapper.textContent = "We're sorry, product customization is not available during store exchanges.";
    
    //add the wrapper right after this one
    this.after(wrapper);
  };
  
};

/**
  * use to show/hide dependent options in the custom-product-options container
  */
class LMCustomProductSelector extends HTMLElement {

  #selector;
   
  constructor() {
    super();
  };

  selector() { return this.#selector; };
  
  connectedCallback()
  {
    this.#selector = this.querySelector('select');
    this.#selector.setAttribute('form', this.closest('custom-product').formId() );
    this.#selector.addEventListener('change', () => this.handleChange() );

    setTimeout( () => this.handleChange(), 10);
  };
  
  handleChange()
  {
    //get the options wrapper if there is one and add an onchange event
    const ns = this.nextElementSibling;
    
    if (ns && ns.tagName.toLowerCase() == 'custom-product-options')
    {
      //if the data-show attribute for the options wrapper contains the value
      //of our selector, then show the wrapper.  otherwise hide it
      const showOptions = ns.dataset?.show ? ns.dataset.show.split(',') : [];
      const isVisible = showOptions.includes(this.#selector.value);
    
      if (isVisible) ns.show();
      else ns.hide();
    }    
  };

  disable()
  {
    this.classList.add('is-disabled');
    this.#selector.disabled = true;
    this.handleChange();
  };

  enable()
  {
    this.classList.remove('is-disabled');
    this.#selector.disabled = false;
    this.handleChange();
  };
};

/**
  * custom selector that updates the _is_customized form 
  * so we can easily track if a form is updated or not
  */
class LMCustomProductEnabler extends LMCustomProductSelector {

  #customizedInput;
  
  connectedCallback()
  {
    super.connectedCallback();
    this.addIsCustomized();
    
    this.selector().addEventListener('change',() => {
      this.#customizedInput.value = this.selector().value;
    });
  };

  isCustomized() {
    return this.#customizedInput.value == 'yes';
  };

  /**
    * adds a hidden form that gets passed through allowing us to
    * filter by customized orders later
    */
  addIsCustomized()
  {
    this.#customizedInput = document.createElement('input');
    this.#customizedInput.setAttribute('type','hidden');
    this.#customizedInput.setAttribute('name','properties[_is_customized]');
    this.#customizedInput.setAttribute('value','no');
    this.#customizedInput.setAttribute('form', this.selector().getAttribute('form') );
    this.before(this.#customizedInput);

    this.#customizedInput.value = this.selector().value;
  };
}

/**
  * where options are stored for a selector or counter
  */
class LMCustomProductOptions extends HTMLElement {

  constructor() {
    super();
  };

  /**
    * returns all children of this container filtering by tag name
    */
  filterChildren(tagName)
  {
    const matchingElements = [];

    // Loop through all child elements of the parent
    for (let i = 0; i < this.children.length; i++) 
    {
      const child = this.children[i];
      if (child.tagName.toLowerCase() == tagName)
      {
        matchingElements.push(child);
      }
    }

    return matchingElements;
  }

  //methods for returning top-level elements within the wrapper
  getOptions() { return this.filterChildren('custom-product-option'); };
  getSelectors() { return this.filterChildren('custom-product-selector'); };
  getCounters() { return this.filterChildren('custom-product-counter'); };

  /**
    * makes the container visible and enables all direct children
    */
  show()
  {
    this.classList.add('is-visible');   
    this.getOptions().forEach( opt => opt.enable() );
    this.getSelectors().forEach( opt => opt.enable() );
    this.getCounters().forEach( opt => opt.enable() );
  };

  /**
    * hides the container visible and disables all direct children
    */
  hide()
  {
    this.classList.remove('is-visible');
    this.getOptions().forEach( opt => opt.disable() );
    this.getSelectors().forEach( opt => opt.disable() );
    this.getCounters().forEach( opt => opt.disable() );
  };
};

/**
  * wrapper for a product option form
  */
class LMCustomProductOption extends HTMLElement {

  constructor()
  {
    super();
  };

  connectedCallback()
  {
    this.setupForm();
    this.applyAttributes();
  };

  formId()
  {
    return this.closest('custom-product').formId();
  }

  //disables the form so it doesn't pass through to the cart
  //and visually updates the container
  disable()
  {
    this.classList.add('is-disabled');
    this.getForm().disabled = true;
  };

  //enable the form so it passes through to the cart
  //and visually updates the container
  enable()
  {
    this.classList.remove('is-disabled');
    this.getForm().disabled = false;
  };
  
  /**
    * this allows us to specify attributes in the options container and have
    * them passed down so we don't have to set them for every option individually
    */
  applyAttributes()
  {
    const optCont = this.closest('custom-product-options');

    if (optCont)
    {
      Object.entries(optCont.dataset).forEach( ([key,value]) => {

        if (key.includes('formAttr'))
        {
          //the attributes are constructed like "data-param-maxlength"
          const attrName = key.replace('formAttr','').toLowerCase();
          this.attr(attrName,value);
        }
      });     
    }    
  };

  /**
    * gets a reference to the actual input form in this container
    */
  getForm()
  {
    let form = this.querySelector('input');
    if (!form) form = this.querySelector('select');
    if (!form) form = this.querySelector('textarea');
    
    return form;
  };

  /**
    * points the input to the shopify form, adds some extra attributes
    * based on form type, sets initial visibility
    */
  setupForm()
  {
    const f = this.getForm();
    if (f) 
    {
      f.setAttribute('form',this.formId());
      
      this.initVisibility();
            
      if (f.tagName.toLowerCase() == 'input' && f.getAttribute('type') == 'number')
      {
        f.setAttribute('inputmode','numeric');
        f.addEventListener('focus', evt => evt.target.select() );
      }
      
    }
  };
  
  /**
    * enables/disabled the form based on the parent
    * container visibility, or its own visibility
    */
  initVisibility()
  {
    //are we in a show/hide container?
    const prodOpts = this.closest('custom-product-options');

    //in a container
    if (prodOpts)
    {
      if (prodOpts.classList.contains('is-visible')) this.enable();
      else this.disable();
    }
    //not in a container
    else
    {
      if (this.classList.contains('is-disabled')) this.disable();
      else this.enable();
    }
    
  }
};

/**
  * used to show or hide a specific number of options based on the counter value
  */
class LMCustomProductCounter extends HTMLElement {

  #counter;
  #optionsWrapper;

  constructor() {
    super();
  };

  connectedCallback()
  {
    //get a reference to the input form and setup some standard attributes
    this.#counter = this.querySelector('input[type="number"]');
    this.#counter.setAttribute('form', this.closest('custom-product').formId() );
    this.#counter.setAttribute('inputmode','numeric');
    this.#counter.addEventListener('focus', evt => evt.target.select() );

    //get a reference to the options wrapper and add our event watcher
    const ns = this.nextElementSibling;
    if (ns && ns.tagName.toLowerCase() == 'custom-product-options')
    {
      this.#optionsWrapper = ns;
      this.#counter.addEventListener('change',() => this.handleChange());

      //if we have a value, populate the forms
      if ( parseInt(this.#counter.value) > 0)
      {
        setTimeout( () => this.handleChange(), 10);
      }
    }
  };

  //disables the form so it doesn't pass through to the cart
  //and visually updates the container
  disable()
  {
    this.classList.add('is-disabled');
    this.#counter.disabled = true;
    this.handleChange();
  };

  //enables the form so it passes through to the cart
  //and visually updates the container
  enable()
  {
    this.classList.remove('is-disabled');
    this.#counter.disabled = false;
    this.handleChange();
  };
  
  handleChange()
  {
     //if set, we're using templates
    if (this.dataset?.formType)
    {
      this.handleTemplateChange();
    }
    //otherwise the child forms are in the page html already
    else
    {
      this.handleToggleChange();
    }
  };

  handleToggleChange()
  {
    const count = parseInt(this.#counter.value);

    if (count > 0) this.#optionsWrapper.show();
    else this.#optionsWrapper.hide();

    this.#optionsWrapper.getOptions().forEach( (opt,idx) => {      
      //show the form
      if (idx < count) opt.enable();
      else opt.disable();
    });
  };

  /**
    * adds options based on our counter value
    * and removes unneeded ones
    */
  handleTemplateChange()
  {
    const count = parseInt(this.#counter.value);
    let curOpts = this.#optionsWrapper.getOptions();

    if (count > 0) this.#optionsWrapper.show();
    else this.#optionsWrapper.hide();

    for (let i = curOpts.length - 1; i >= count; i--) 
    {
      this.#optionsWrapper.removeChild(curOpts[i]);
    }

    curOpts = this.#optionsWrapper.getOptions();

    for (let i=0; i<count; i++)
    {
      if ( i >= curOpts.length ) this.addOption(i+1);
     }
  };

  /**
    *	Template example
    *	<custom-product-counter data-form-type="input" data-input-type="number" data-input-name="Name ${i}" data-attr-min=0 data-attr-max=12>
    */
  addOption(optionIndex)
  {
    const params = {
      "i": optionIndex
    }

    const formType = this.dataset.formType;
    const inputType = this.dataset?.inputType || "text";
    const formName = this.dataset.formName;
    const formLabel = this.dataset?.formLabel || formName;
    
    //build the label
    const optLabel = document.createElement('label');
    optLabel.textContent = this.interpolate(formLabel,params);

    //build the form w/ type.  attributes will be set by extended element automatically
    const optForm = document.createElement(formType);
    optForm.setAttribute('type',inputType);  
    optForm.setAttribute('name',this.interpolate(formName,params));
    
    //put it all together    
    const optCont = document.createElement('custom-product-option');
    optCont.appendChild(optLabel);
    optCont.appendChild(optForm);
    this.#optionsWrapper.appendChild(optCont);
  }
  
  interpolate(template, variables) {
    return template.replace(/\$\{([^}]+)\}/g, (match, name) => variables[name.trim()] || '');
  };
  
};

//link our elements to their classes
customElements.define('custom-product',LMCustomProduct);
customElements.define('custom-product-selector',LMCustomProductSelector);
customElements.define('custom-product-enabler',LMCustomProductEnabler);
customElements.define('custom-product-counter',LMCustomProductCounter);
customElements.define('custom-product-options',LMCustomProductOptions);
customElements.define('custom-product-option',LMCustomProductOption);
